<dialog
	#dialogRef
	[attr.open]="isOpen || null"
	class="modal--dialog-container"
	[@enterAnimation]
>
	<div class="modal--overlay" (click)="close()"></div>
	<div class="modal--content-wrapper" [class.modal--content-show]="isOpen">
		<div class="modal--content-container">
			<ng-content></ng-content>
		</div>
	</div>
</dialog>
